var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDesktopIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 14.875V15.7145C7.5 16.3775 7.23661 17.0134 6.76777 17.4822L6.25 18H13.75L13.2322 17.4822C12.7634 17.0134 12.5 16.3775 12.5 15.7145V14.875M17.5 4.875V13C17.5 14.0355 16.6605 14.875 15.625 14.875H4.375C3.33947 14.875 2.5 14.0355 2.5 13V4.875M17.5 4.875C17.5 3.83947 16.6605 3 15.625 3H4.375C3.33947 3 2.5 3.83947 2.5 4.875M17.5 4.875V10.5C17.5 11.5355 16.6605 12.375 15.625 12.375H4.375C3.33947 12.375 2.5 11.5355 2.5 10.5V4.875",
    stroke: "#667085",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktopIcon);
export default __webpack_public_path__ + "static/media/desktopIcon.52ab340e3a52a7f8840feea77ac8e339.svg";
export { ForwardRef as ReactComponent };